import { Transform } from 'class-transformer';
import { IsOptional } from 'class-validator';
import { AccountAddressDto } from '../account-addresses/account-address.dto';
import { sanitizeString } from '../utils';
import { CaseLineDto } from './case-line.dto';
import { CasePickupUpdateDto } from './case-pickup-update.dto';
import { CaseReturnRequestType } from './case-return-request.enum';
import { CaseType } from './case-type.enum';

/**
 * DTO to update a Case. The fields are not decorated with validations because UI allows the user to save as they edit.
 */
export class CaseUpdateDto {
  @Transform(({ value }) => sanitizeString(value))
  public reason: string;

  @IsOptional()
  @Transform(({ value }) => sanitizeString(value))
  public description?: string;

  @IsOptional()
  public parcelCount?: number;

  @IsOptional()
  public palletCount?: number;

  @IsOptional()
  public pickup?: CasePickupUpdateDto;

  @IsOptional()
  public requestType?: CaseReturnRequestType;

  @IsOptional()
  public address?: AccountAddressDto;

  public accountId: string;

  public type: CaseType;

  public lines: CaseLineDto[];
}
